const stats = [
  { value: "1000+", label: "Deltagare sedan 2019" },
  { value: "60", label: "Minuter per träff" },
  { value: "3-5", label: "Personer per grupp" },
];

const StatsBand = () => {
  return (
    <section className="py-12 px-4 bg-accent">
      <div className="container mx-auto max-w-4xl">
        <div className="flex flex-wrap justify-center gap-6 text-center text-white">
          {stats.map((stat) => (
            <div key={stat.label} className="p-4 min-w-[140px]">
              <div className="text-3xl md:text-4xl font-bold mb-1">{stat.value}</div>
              <div className="text-white/85 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBand;
